import type { formItemProps } from "../../../components/editForm/data";
import type { ColumnsType } from "antd/es/table";

export type FormConfigType = formItemProps[];

// 默认查询数据
export const DEFAULT_QUERY_DATA = {
    ChannelId: undefined,
    CountryId: undefined,
};

// 生成查询表单配置
export const generateQueryFormConfig = (options: any): FormConfigType => {
    return [
        {
            title: "通道",
            field: "ChannelId",
            type: "select",
            placeholder: "请选择通道",
            options: options?.channelOptions || [],
            fieldNames: { label: 'name', value: 'id' },
            allowClear: true,
            style: {
                width: 200
            }
        },
        {
            title: "国家",
            field: "CountryId",
            type: "select",
            placeholder: "请选择国家",
            options: options?.countryOptions || [],
            fieldNames: { label: 'name', value: 'id' },
            allowClear: true,
            style: {
                width: 200
            }
        },
    ];
};

// 生成表格列配置
export const generateTableColumns = (): ColumnsType => {
    return [
        {
            title: "ID",
            dataIndex: "Id",
            key: "Id",
        },
        {
            title: "通道",
            dataIndex: ["Channel", "Name"],
            key: "ChannelName",
        },
        {
            title: "国家",
            dataIndex: ["Country", "NameCn"],
            key: "CountryName",
        },
        {
            title: "滑点",
            dataIndex: "Slippage",
            key: "Slippage",
        },
        {
            title: "创建时间",
            dataIndex: "CreatedAtString",
            key: "CreatedAtString",
        },
    ];
};